import { Component, OnInit } from '@angular/core';
import { ApiService } from './services/api.service';
import { AppService } from './services/app.service';
import { DataService } from './services/data.service';
import { forkJoin } from 'rxjs';
import { environment } from 'projects/environments/environment';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  public version: string = environment.version;
  public sysType: string | null = null;

  constructor(
    public app: AppService,
    private api: ApiService,
    private data: DataService,
    private primengConfig: PrimeNGConfig
  ) { }

  ngOnInit(): void {
    // prime config
    this.primengConfig.overlayOptions = {
      appendTo: 'body'
    };
    // get sysinfo and setup
    forkJoin([
      this.api.getSysinfo(),
      this.api.getSetup()
    ]).subscribe({
      next: (result: any) => {
        if (result[0].data.env) {
          this.app.setEnv(result[0].data?.env);
          this.app.setFeatures(result[0].data?.features);
        }
        if (result[1].data.timezones) {
          this.data.setTimezones(result[1].data.timezones);
        }
      }
    });
  }

}
